import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Worksite } from '../models/question/question-worksite.model';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseWorksiteService {
  protected worksites: Worksite[];
  protected financiers: { parentWorksiteId: string; worksite: Worksite }[];
  private coordinatorWorksiteId: string;
  public effektaWorksites: Worksite[];
  public hasBeslut: boolean;
  private worksitesSubject = new BehaviorSubject<Worksite[]>([]);
  public worksites$ = this.worksitesSubject.asObservable();

  setWorksites(worksites: Worksite[]) {
    this.worksites = worksites;
    this.worksitesSubject.next(this.worksites);
  }

  addWorksite(worksite: Worksite) {
    if (!this.worksites) {
      this.worksites = [];
    }
    // Check if worksite already exists to avoid duplicates
    if (!this.worksites.some((w) => w.id === worksite.id)) {
      this.worksites = [...this.worksites, worksite];
      this.worksitesSubject.next(this.worksites);
    }
  }

  addFinancier(worksite: Worksite, parentWorksiteId: string): void {
    if (!this.financiers) {
      this.financiers = [];
    }
    this.financiers = [...this.financiers, { parentWorksiteId, worksite }];
  }

  getWorksite(worksiteId: string): Observable<Worksite> {
    const worksite = this.worksites.find((w) => w.id === worksiteId);
    if (worksite) {
      return of(worksite);
    }
    return of(undefined);
  }

  getFinancier(
    worksiteId: string,
    parentWorksiteId: string,
  ): Observable<Worksite> {
    const financier = this.financiers.find(
      (f) =>
        f.parentWorksiteId === parentWorksiteId && f.worksite.id === worksiteId,
    );
    if (financier) {
      return of(financier.worksite);
    }
    return of(undefined);
  }

  getWorksiteValue(worksiteId: string): Worksite {
    return this.worksites.find((w) => w.id === worksiteId);
  }

  getAllWorksites(): Worksite[] {
    return this.worksites || [];
  }

  removeWorksite(worksiteId: string): void {
    if (!this.worksites) {
      return;
    }
    this.worksites = this.worksites.filter((w) => w.id !== worksiteId);
    this.worksitesSubject.next(this.worksites);
  }

  getFinancierValue(worksiteId: string, parentWorksiteId: string): Worksite {
    return this.financiers.find(
      (f) =>
        f.parentWorksiteId === parentWorksiteId && f.worksite.id === worksiteId,
    )?.worksite;
  }

  setCoordinatorWorksiteId(coordinatorWorksitId: string) {
    this.coordinatorWorksiteId = coordinatorWorksitId;
  }

  getCoordinatorWorksiteId(): string {
    return this.coordinatorWorksiteId;
  }

  resetWorksites() {
    this.worksites = [];
    this.financiers = [];
    this.coordinatorWorksiteId = undefined;
    this.effektaWorksites = [];
    this.hasBeslut = false;
  }
}
